import { Component, OnDestroy, AfterContentInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {CommonModalBase} from "../common/commonModalBase.abstract";
import {ModalCancelSubscriptionInterface, reason, reasonSelector} from "./modal-cancel-subscription.interface";
import {CommonModalService} from "../../common-modal/common-modal.service";
import {CommonModalTemplatesEnum} from "../all-modals-config";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'v-modal-cancel-subscription',
  templateUrl: './modal-cancel-subscription.component.html'
})
export class ModalCancelSubscriptionComponent extends CommonModalBase<ModalCancelSubscriptionInterface> implements AfterContentInit, OnDestroy {
  public cancelReasons: ({name :string, id: string})[] = [];
  public selectedReason: reasonSelector|'' = '';
  public submitReady = false;
  public cancelReasonsForm: FormGroup;
  public submitted = false;
  private destroyed$ = new Subject<void>();

  constructor(
    commonModalService: CommonModalService,
    private formBuilder: FormBuilder
  ) {
    super(
      commonModalService,
      CommonModalTemplatesEnum.CANCEL_SUBSCRIPTION
    );

    this.buildForm();
  }

  ngAfterContentInit() {
    this.cancelReasons = this.modalData.cancelReasons.map((reason: reason) => ({
      id: reason.uid,
      name: reason.title
    }));
    this.setReasonValidator();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  hideFunc(event: MouseEvent): void {
    if (this.modalData && typeof this.modalData.hidePopupBtn === 'function') {
      this.modalData.hidePopupBtn(event)
    }
  }

  buildForm() {
    this.cancelReasonsForm = this.formBuilder.group({
      reason: [null]
    });
  }

  get f() { return this.cancelReasonsForm.controls; }

  setReasonValidator() {
    const controls = this.cancelReasonsForm.get('reason');

    controls.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((reason: reasonSelector) => {
        reason ? this.submitReady = true : this.submitReady = false;
      });
  }

  onSubmit(formData): void {
    this.submitted = true;
    if (this.cancelReasonsForm.controls.reason.value) {
      const form = <HTMLFormElement>document.getElementById(this.modalData.cancelReasonsForm);
      const reason = <HTMLInputElement>form.elements[0];

      this.submitReady = false;
      reason.value = formData.reason;
      form.submit();
    }
  }
}
